import { render, staticRenderFns } from "./BtnIntegrarAditivoContrato.vue?vue&type=template&id=a92b047c"
import script from "./BtnIntegrarAditivoContrato.vue?vue&type=script&lang=js"
export * from "./BtnIntegrarAditivoContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports